import Spacings from '@dynatrace/strato-design-tokens/spacings';
import {
  BarChartIcon,
  StackedAreaChartIcon,
  HeatmapIcon,
  LineChartIcon,
} from '@dynatrace/strato-icons';

import { shapeIconWrapper } from './xy-legend.sty.js';
import { ShapeIcon } from '../../../../core/components/shape/ShapeIcon.js';
import type { VariantShape } from '../../../../core/components/shape/type.js';

export const LINE_CHART_ICON_SHAPE = 'line-chart';
export const BAR_CHART_ICON_SHAPE = 'bar-chart';
export const RECT_CHART_ICON_SHAPE = 'rect-chart';
export const AREA_CHART_ICON_SHAPE = 'area-chart';

interface LegendIconProps {
  shape:
    | VariantShape
    | typeof LINE_CHART_ICON_SHAPE
    | typeof BAR_CHART_ICON_SHAPE
    | typeof RECT_CHART_ICON_SHAPE
    | typeof AREA_CHART_ICON_SHAPE;
  color: string;
}

const iconBaseStyle = {
  width: Spacings.Size12,
  height: Spacings.Size12,
  display: 'block',
};

export const XYLegendIcon = ({ color, shape }: LegendIconProps) => (
  <div className={shapeIconWrapper}>
    {(() => {
      switch (shape) {
        case LINE_CHART_ICON_SHAPE:
          return <LineChartIcon style={{ color: color, ...iconBaseStyle }} />;
        case BAR_CHART_ICON_SHAPE:
          return <BarChartIcon style={{ color: color, ...iconBaseStyle }} />;
        case AREA_CHART_ICON_SHAPE:
          return (
            <StackedAreaChartIcon style={{ color: color, ...iconBaseStyle }} />
          );
        case RECT_CHART_ICON_SHAPE:
          return <HeatmapIcon style={{ color: color, ...iconBaseStyle }} />;
        default:
          return <ShapeIcon color={color} shape={shape} />;
      }
    })()}
  </div>
);
